// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","913":"BusinessProGuestLazyComponent"}[chunkId] + "." + {"46":"319448c3c3918e97f06c","913":"cb8ff57d5cf08ea28dd5"}[chunkId] + ".js";
};